import { SimpleGrid, Text } from "@chakra-ui/react";
import Spinner from "../../../shared/components/Spinner";
import ReadingOrderCard from "./ReadingOrderCard";
// import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { usePremium } from "../../../contexts/Premium";
import { getReadingOrder } from "../../../services/readingOrdersApi";

const BrowseList = ({ type, franchise }) => {
  const { isPremium } = usePremium();
  const query = useQuery(["readingOrders", type, franchise], () =>
    getReadingOrder(type, franchise)
  );
  const readingOrders = Array.isArray(query.data?.data)
    ? query.data.data
    : null;

  if (query.isLoading) {
    return <Spinner />;
  }

  if (query.isError || !readingOrders) {
    return <Text>Unable to load reading orders.</Text>;
  }

  if (!readingOrders.length) {
    return <Text>Nothing to show</Text>;
  }

  return (
    <SimpleGrid columns={[1, 2, 2, 3]} spacing="16px">
      {readingOrders.map((readingOrder) => {
        const premiumOnly = Boolean(
          readingOrder.paywallPremiumOnly ?? readingOrder.premiumOnly
        );
        return (
          <ReadingOrderCard
            key={readingOrder.id}
            id={readingOrder.id}
            title={readingOrder.title}
            thumbnail={readingOrder.thumbnail}
            comicsCount={readingOrder.comicsCount}
            readersCount={
              readingOrder.readersCount ?? readingOrder.readingCount
            }
            years={readingOrder.years}
            author={readingOrder.author}
            readingCount={readingOrder.readingCount}
            premiumOnly={premiumOnly}
            isPremium={isPremium}
            isBookClub={Boolean(readingOrder.bookClub)}
            hideStartAction
          />
        );
      })}
    </SimpleGrid>
  );
};

export default BrowseList;
